module.exports = __webpack_public_path__ + "static/media/normattiva.158263b2.png";